module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/online-portal-5.eee724f7.svg";